import React, { useEffect, useState } from 'react';
import { CheckboxGroup, Flex, Text, useCheckboxGroup } from '@chakra-ui/react';
import { DropdownIcon } from '../../../../utils/icons/dropdown';
import { Checkable } from './Checkable/checkable';

export interface ICategoryValue {
	value: string;
	name: string;
	icon?: React.ReactNode;
}

export const Category = ({
	header,
	data,
	handleDataChange,
	defaultValues = [],
}: {
	header: string;
	data: ICategoryValue[];
	handleDataChange: React.Dispatch<React.SetStateAction<string[]>>;
	defaultValues?: ICategoryValue['value'][];
}) => {
	const [isCollapsed, setIsCollapsed] = useState(false);

	const { value: checkedCategoryValues, getCheckboxProps } = useCheckboxGroup({
		defaultValue: defaultValues ?? [],
	});

	const handleCollapseSwitch = () => setIsCollapsed(previous => !previous);

	useEffect(() => {
		handleDataChange(checkedCategoryValues.map(value => value.toString()));
	}, [checkedCategoryValues]);

	return (
		<Flex
			flexDirection="column"
			gridGap="28px"
			height={isCollapsed ? '42px' : 'unset'}
			overflow="hidden"
			borderBottom="1px solid #FFFFFF40"
			_last={{ border: 'none' }}
			paddingBottom="28px"
			lineHeight="14px"
		>
			<Flex
				justifyContent="space-between"
				alignItems="center"
				cursor="pointer"
				onClick={handleCollapseSwitch}
			>
				<Text textTransform="uppercase">{header}</Text>
				<DropdownIcon isInverted={isCollapsed} />
			</Flex>
			<CheckboxGroup variant="unstyled">
				<Flex
					flexDirection="column"
					gridGap="24px"
				>
					{data.map(data => (
						<Checkable
							key={data.value}
							{...getCheckboxProps({ value: data.value, data })}
						/>
					))}
				</Flex>
			</CheckboxGroup>
		</Flex>
	);
};
